import { z } from 'zod';

export default z.object({
  FEATURE_ACCESSORIES: z.string(),
  FEATURE_RETURN_FLOW: z.string(),
  FEATURE_STORAGE_BAG: z.string(),
  FEATURE_BOOKING_TOOL: z.string(),
  FEATURE_CUSTOMER_SERVICE_FORM: z.string(),
  FEATURE_PRODUCTS_SLIDER: z.string(),
  FEATURE_RELAXATION_MASK: z.string(),
  FEATURE_APP_PAGE: z.string(),
  FEATURE_EXPANSION_MARKETS_ORDER_FLOW: z.string(),
  FEATURE_LIFETIME_SUBSCRIPTION: z.string(),
  FEATURE_ACCOUNT_SUBSCRIPTION_ACTIONS: z.string(),
  FEATURE_SOCIAL_LOGIN: z.string(),
  FEATURE_MAGAZINE: z.string(),
});
